import { Component, Input, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { ResponseData } from 'src/app/helper/interface/response';
import { MasterApiService } from 'src/app/modules/master/service/master-api.service';

@Component({
  selector: 'app-print-doc',
  templateUrl: './print-doc.component.html',
  styleUrl: './print-doc.component.scss'
})
export class PrintDocComponent implements OnInit{
  @Input() docId: any = '';
  @Input() docContent: any = '';
  dataLoading: boolean = false;
  public _printStyle: Array<any> = [];
  public onClose: Subject<any> = new Subject();
  @Input() printSectionId: string = 'print-section';
  @Input() printTitle: string = '';
  @Input() useExistingCss = false;
  @Input() printDelay: number = 0;
  private _styleSheetFile = '';
  @Input()
  set printStyle(values: { [key: string]: { [key: string]: string } }) {
    for (let key in values) {
      if (values.hasOwnProperty(key)) {
        this._printStyle.push((key + JSON.stringify(values[key])).replace(/['"]+/g, ''));
      }
    }
    this.returnStyleValues();
  }

  @Input()
  set styleSheetFile(cssList: string) {
    let linkTagFn = function (cssFileName: string) {
      return `<link rel="stylesheet" type="text/css" href="${cssFileName}">`;
    }
    if (cssList.indexOf(',') !== -1) {
      const valueArr = cssList.split(',');
      for (let val of valueArr) {
        this._styleSheetFile = this._styleSheetFile + linkTagFn(val);
      }
    } else {
      this._styleSheetFile = linkTagFn(cssList);
    }
  }


  constructor(private masterApi: MasterApiService, private _bsModalRef: BsModalRef, private sanitizer: DomSanitizer) { }

  ngOnInit(): void {
  }

  setInput(data: any) {
    if (data.id) {
      this.docId = data.id;
      this.getDataDoc(data);
    } else if (data.docContent) {
      this.docContent = data.docContent;
      this.print();
    }
  }
  
  getDataDoc(data: any) {
    if (this.docId) {
      this.dataLoading = true;
      if(data?.type){
        this.masterApi.getDownContent(this.docId).then((res: any) => {
          if (res.result.body) {
            const opt: any = res.result.body;
            this.docContent = this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizer.bypassSecurityTrustHtml(opt));
            this.print();
          }
        }).finally(() => this.dataLoading = false)
      }
      else{
      this.masterApi.getDocContent(this.docId).then((res: ResponseData) => {
        if (res.result.body) {
          const opt: any = res.result.body;
          this.docContent = this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizer.bypassSecurityTrustHtml(opt));
          this.print();
        }
      }).finally(() => this.dataLoading = false)
    }
  }
  }

  private returnStyleSheetLinkTags() {
    return this._styleSheetFile;
  }
  private getElementTag(tag: keyof HTMLElementTagNameMap): string {
    const html: string[] = [];
    const elements = document.getElementsByTagName(tag);
    for (let index = 0; index < elements.length; index++) {
      html.push(elements[index].outerHTML);
    }
    return html.join('\r\n');
  }


  public returnStyleValues() {
    const a = `td, span {
      color : black;
      text-align :justify;
      word-spacing : 1px;
  color: rgb(34, 34, 34);
  font-size : 12px;
   text-align: start;}
  .small-text{
      font-size : 11px;
  }
  th ,.label { 
   font-size:13px;
   font-weight: bold;
  }`
    return `<style> ${a}</style>`
    //return `<style> ${this._printStyle.join(' ').replace(/,/g, ';')} </style>`;
  }
  /**
   * 
   * @param data the html element collection to save defaults to
   * 
   */

  private getFormData(data: any) {
    for (var i = 0; i < data.length; i++) {
      data[i].defaultValue = data[i].value;
      if (data[i].checked) {
        data[i].defaultChecked = true;
      }
    }
  }

  /**
   * @returns html section to be printed along with some associated inputs
   * 
   */
  private getHtmlContents() {
    let printContents: any = document.getElementById(this.printSectionId);
    let innards = printContents.getElementsByTagName('input');
    this.getFormData(innards);

    let txt = printContents.getElementsByTagName('textarea');
    this.getFormData(txt);

    return printContents.innerHTML;
  }


  public print(): void {
    let printContents, popupWin: any, styles = '', links = '';
    const baseTag = this.getElementTag('base');

    if (this.useExistingCss) {
      styles = this.getElementTag('style');
      links = this.getElementTag('link');
    }

    printContents = this.docContent || this.getHtmlContents();
    popupWin = window.open("", "_blank", "top=0,left=0,height=auto,width=auto");
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>${this.printTitle ? this.printTitle : ""}</title>
          ${baseTag}
          ${this.returnStyleValues()}
          ${this.returnStyleSheetLinkTags()}
          ${styles}
          ${links}
        </head>
        <body>
          ${printContents}
          <script defer>
            function triggerPrint(event) {
              window.removeEventListener('load', triggerPrint, false);
              setTimeout(function() {
                closeWindow(window.print());
              }, ${this.printDelay});
            }
            function closeWindow(){
                window.close();
            }
            window.addEventListener('load', triggerPrint, false);
          </script>
        </body>
      </html>`);
    popupWin.document.close();
    this._bsModalRef.hide();
    this.onClose.next(true);
  }
}
